const FONT_MAP = {
  'sans-serif': 'ui-sans-serif, system-ui, sans-serif',
  serif: 'ui-serif, Georgia, serif',
  monospace: 'ui-monospace, monospace',
};

export default function QrFrame({
  type,
  phrase,
  frameColor,
  textColor,
  font,
  children,
}) {
  if (type === 'none') {
    return <>{children}</>;
  }

  const fontFamily = FONT_MAP[font] || FONT_MAP['sans-serif'];

  if (type === 'banner') {
    return (
      <div
        className="inline-flex flex-col overflow-hidden rounded-xl shadow-sm"
        style={{ border: `4px solid ${frameColor}` }}
      >
        <div className="bg-white p-3">{children}</div>
        <div
          className="px-4 py-2.5 text-center text-xs font-bold uppercase tracking-widest"
          style={{
            backgroundColor: frameColor,
            color: textColor,
            fontFamily,
          }}
        >
          {phrase || 'SCAN ME'}
        </div>
      </div>
    );
  }

  if (type === 'border') {
    return (
      <div
        className="inline-block rounded-lg bg-white p-3"
        style={{ border: `6px solid ${frameColor}` }}
      >
        {children}
      </div>
    );
  }

  if (type === 'rounded') {
    return (
      <div
        className="inline-block rounded-3xl bg-white p-4"
        style={{ border: `5px solid ${frameColor}`, boxShadow: `0 0 0 2px ${frameColor}22` }}
      >
        {children}
      </div>
    );
  }

  return <>{children}</>;
}
